/**
 * Base class for image requests sent to the request queue.
 */
export class BaseRequest {
  /**
   * Used by the request queue to prioritize the request. Must be set by child class.
   * @type {string}
   */
  position = '';

  /**
   * Actions to be performed when texture is loaded.
   * @param response
   */
  onTextureLoaded (response) { /* to be supplied by consumer */ }

  /**
   * Method to build a url. Must be overridden.
   * @param builder
   */
  getUrl (builder) { /* to be overridden by child class */ }
}
